module.exports = __webpack_public_path__ + "a4fabb9fb03af6a0ff44b48b68bab013.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/diamond-shapes/images/round.png
// module id = 763
// module chunks = 0